import { useState, useEffect } from "react"
import { PageWrapper } from "@components/page-wrapper"
import { Modal } from "@components/modal"
import { Stack, Typography, Button } from "@mui/material"
import { useRouteError } from "react-router-dom"

export default function ErrorPage({ open = true, solidBg }: any) {
  const [modalOpen, setModalOpen] = useState(open)
  useEffect(() => {
    setModalOpen(open)
  }, [open])
  const error = useRouteError()
  if (open) {
    console.error("error", error)
  }

  const handleRedirect = () => {
    window.location.href = "/dashboard"
  }

  return (
    <PageWrapper>
      <Modal open={modalOpen} solidBg={solidBg} float>
        <Stack spacing={3}>
          <Typography align="center" variant="h6">
            Something unexpected happened
          </Typography>
          <Typography align="center">
            We're sorry, an unexpected error has occurred. Click the "Refresh"
            button to go back to home page. If error persists, please chat with
            our customer service
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              setModalOpen(false)
              handleRedirect()
            }}
          >
            Refresh
          </Button>
        </Stack>
      </Modal>
      {/* <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p> */}
    </PageWrapper>
  )
}
